// React
import { createContext } from "react"

// Types
import type { DataType } from "../types"
import type { DetailType } from "../utils"

export const DataContext = createContext<{
  data: DataType
  onAddDetail: (value: DetailType) => void
}>({
  data: {
    address: "",
    approve_by: "",
    approve_status: 0,
    detailreject: [],
    location_id: 0,
    reject_id: 0,
    reject_status: 0,
    transaction_date: "",
    trx_code: "",
    vendor_id: 0
  },
  onAddDetail(_) {},
})